// Language-neutral timeline structure. Translatable text (title/summary/details)
// lives in the locale files keyed by `id`. Each entry is sourced.

export const CATEGORIES = [
  "earlyLife",
  "music",
  "film",
  "dance",
  "fashion",
  "business",
  "legacy",
];

export const TIMELINE = [
  { id: "birth-1969", year: "1969", category: "earlyLife", sourceLabel: "Britannica", sourceUrl: "https://www.britannica.com/biography/Jennifer-Lopez", verified: true },
  { id: "bronx-1970s", year: "1970s", category: "earlyLife", sourceLabel: "Britannica", sourceUrl: "https://www.britannica.com/biography/Jennifer-Lopez", verified: true },
  { id: "dance-1980s", year: "1980s", category: "dance", sourceLabel: "Britannica", sourceUrl: "https://www.britannica.com/biography/Jennifer-Lopez", verified: true },
  { id: "living-color-1991", year: "1991", category: "dance", sourceLabel: "Britannica", sourceUrl: "https://www.britannica.com/biography/Jennifer-Lopez", verified: true },
  { id: "acting-start-1995", year: "1995", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/name/nm0000182/", verified: true },
  { id: "selena-1997", year: "1997", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt0120094/", verified: true },
  { id: "out-of-sight-1998", year: "1998", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt0120701/", verified: true },
  { id: "on-the-6-1999", year: "1999", category: "music", sourceLabel: "Billboard", sourceUrl: "https://www.billboard.com/artist/jennifer-lopez/", verified: true },
  { id: "jlo-album-2001", year: "2001", category: "music", sourceLabel: "Billboard", sourceUrl: "https://www.billboard.com/artist/jennifer-lopez/", verified: true },
  { id: "wedding-planner-2001", year: "2001", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt0209475/", verified: true },
  { id: "this-is-me-then-2002", year: "2002", category: "music", sourceLabel: "Billboard", sourceUrl: "https://www.billboard.com/artist/jennifer-lopez/", verified: true },
  { id: "maid-in-manhattan-2002", year: "2002", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt0252501/", verified: true },
  { id: "brand-fragrance-2005", year: "2005", category: "business", sourceLabel: "Britannica", sourceUrl: "https://www.britannica.com/biography/Jennifer-Lopez", verified: true },
  { id: "american-idol-2011", year: "2011", category: "legacy", sourceLabel: "Britannica", sourceUrl: "https://www.britannica.com/biography/Jennifer-Lopez", verified: true },
  { id: "aka-2014", year: "2014", category: "music", sourceLabel: "Billboard", sourceUrl: "https://www.billboard.com/artist/jennifer-lopez/", verified: true },
  { id: "hustlers-2019", year: "2019", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt5503686/", verified: true },
  { id: "super-bowl-2020", year: "2020", category: "legacy", sourceLabel: "Billboard", sourceUrl: "https://www.billboard.com/artist/jennifer-lopez/", verified: true },
  { id: "marry-me-2022", year: "2022", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt6772950/", verified: true },
  { id: "this-is-me-now-2024", year: "2024", category: "music", sourceLabel: "Billboard", sourceUrl: "https://www.billboard.com/artist/jennifer-lopez/", verified: true },
  { id: "atlas-2024", year: "2024", category: "film", sourceLabel: "IMDb", sourceUrl: "https://www.imdb.com/title/tt20247888/", verified: true },
];

export const PILLARS = ["music", "film", "dance", "fashion", "business", "impact"];

export const DISCOGRAPHY = [
  { id: "on-the-6", year: "1999" },
  { id: "jlo", year: "2001" },
  { id: "this-is-me-then", year: "2002" },
  { id: "love", year: "2011" },
  { id: "aka", year: "2014" },
  { id: "this-is-me-now", year: "2024" },
];

export const FILMOGRAPHY = [
  { id: "selena", year: "1997" },
  { id: "out-of-sight", year: "1998" },
  { id: "the-wedding-planner", year: "2001" },
  { id: "maid-in-manhattan", year: "2002" },
  { id: "monster-in-law", year: "2005" },
  { id: "hustlers", year: "2019" },
  { id: "marry-me", year: "2022" },
  { id: "the-mother", year: "2023" },
  { id: "atlas", year: "2024" },
];

export const FAQ_IDS = ["official", "where-website", "where-store", "affiliated", "about"];

// Curated abstract / copyright-safe imagery (no JLo photos).
export const IMAGES = {
  heroGold: "https://images.unsplash.com/photo-1741356474365-5f0041f89eaa?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  stageLights: "https://images.unsplash.com/photo-1773769234826-65edeac80f99?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  goldStreaks: "https://images.unsplash.com/photo-1741356474357-72188f76e801?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  lightTrails: "https://images.unsplash.com/photo-1780592015570-856606bbeead?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  skyline: "https://images.unsplash.com/photo-1664353655151-9d94a9170eb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  bridge: "https://images.pexels.com/photos/462267/pexels-photo-462267.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  redCarpet: "https://images.unsplash.com/photo-1761699890197-46dda22b17b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};
